import md5 from "md5";

/**
 * 拼接对象为url的GET请求字符串
 * @param {Object} obj - 待拼接的对象
 * @returns {string} - 拼接成的请求字符串
 */
export function encodeSearchParams(obj) {
	var params = [];

	for(let key in obj) {
		let value = obj[key]

		// 对于需要编码的文本（比如说中文）我们要进行编码
		params.push([key, encodeURIComponent(value)].join('='))
	}

	return params.join('&')
}

/**
 * 拼接对象为url的GET请求字符串（文本不编译）
 * @param {Object} obj - 待拼接的对象
 * @returns {string} - 拼接成的请求字符串
 */
export function encodeSearchParams2(obj) {
	var params = [];

	for(let key in obj) {
		let value = obj[key]

		// 对于需要编码的文本（比如说中文）我们要进行编码
		params.push([key, value].join('='))
	}

	return params.join('&')
}

/**
 * 对象排序（升序）
 * @param {Object} obj - 待排序的对象
 */
export function sortObj(obj) {
    var newkey = Object.keys(obj).sort();
　　//先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var newObj = {};//创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj;//返回排好序的新对象
}


/**
 * 签名验证
 * @param data
 * @param sign
 * @param md5Key
 * @returns {boolean}
 */
export function signVerify(data, sign, md5Key)
{
	let cre_sign = md5("response=" + encodeURIComponent(data) + "&sign=" + md5Key);
	return cre_sign === sign
}

/**
 * 判断变量是否存在
 * @param value - 变量
 */
export function valueCheck(value) {
    if (typeof(value)=="undefined")  {
		return false;
    } else {
		return true;
    }
}

/**
 * 过滤数组内字符串两边空格和空字符串
 * @param data - 数组
 */
export function trimArray(data) {
	let res = {}
    for(var i in data) {
		if (typeof(data[i]) != "undefined") {
			if (typeof(data[i]) == 'string') {
				res[i] = data[i].replace(/(^\s*)|(\s*$)/g, "");
			}else {
				res[i] = data[i]
			}
		}
	}
	return res;
}

/**
 * 十位时间戳转换成日期格式
 * @param timeStamp - 时间戳
 * @param format - 返回格式，支持自定义，但参数必须与formateArr里保持一致
 */
export function formatDate(number = timest(),format = 'Y-M-D h:m:s') {
	var formateArr  = ['Y','M','D','h','m','s'];
	var returnArr   = [];

	var date = new Date(number * 1000);
	returnArr.push(date.getFullYear());
	returnArr.push(formatNumber(date.getMonth() + 1));
	returnArr.push(formatNumber(date.getDate()));

	returnArr.push(formatNumber(date.getHours()));
	returnArr.push(formatNumber(date.getMinutes()));
	returnArr.push(formatNumber(date.getSeconds()));

	for (var i in returnArr)
	{
	format = format.replace(formateArr[i], returnArr[i]);
	}
	return format;
}
/**
 * 获取时间日期格式
 * @param d - 时间
 * @param f - 返回格式，
 */
export function formatTime(d, f) {
	var o = {
		"M+": d.getMonth() + 1,
		"d+": d.getDate(),
		"h+": d.getHours(),
		"m+": d.getMinutes(),
		"s+": d.getSeconds(),
		"q+": Math.floor((d.getMonth() + 3) / 3),
	};
	if (/(y+)/.test(f)){
		f = f.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o){
		if (new RegExp("(" + k + ")").test(f)){
			f = f.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}

	return f;
}
//数据转化
function formatNumber(n) {
	n = n.toString()
	return n[1] ? n : '0' + n
}


//返回10位时间戳
export function timest() {
  var tmp = Date.parse( new Date() ).toString();
  tmp = tmp.substr(0,10);
  return tmp;
}


//对象转数组
export function objToArray(obj) {
	var arr = []
	for (let i in obj) {
		arr.push(obj[i]); //属性=
	}
  return arr;
}

/**
 * 富文本中图片输出处理
 * @param {string} data - 富文本字符串
 * @returns {string} url - 图片base域名
 */
export function htmlReplaceImgUrl(data,url) {
	url = url.replace(/\/$/,'')
	var imgReg = /<img.*?(?:>|\/>)/gi;
	//匹配src属性
	var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
	var arr = data.match(imgReg);
	if (arr) {

		let imgs = []
		for (var i = 0; i < arr.length; i++) {
			var src = arr[i].match(srcReg);
			//获取图片地址
			if(src[1] && imgs.indexOf(src[1]) == -1){
				let reg = "/"+src[1]+"/g";
				data=data.replace(RegExp(src[1],'g'),url+src[1]+'?x-oss-process=image/resize,w_750');
				imgs.push(src[1])
			}
		}
	}
	data=data.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
	return data
}


// export function checkPhone(text) {
// 				  return text.match(/((((13[0-9])|(15[^4])|(18[0,1,2,3,5-9])|(17[0-8])|(147))\d{8})|((\d3,4|\d{3,4}-|\s)?\d{7,14}))?/g);
// 			},
export function clickPhone(e) {
	var phone = e
	var phone_list = phone.match(/((((13[0-9])|(15[^4])|(18[0,1,2,3,5-9])|(17[0-8])|(147))\d{8})|((\d3,4|\d{3,4}-|\s)?\d{7,14}))?/g);
	var yse_phone = []
	for (var i = 0; i < phone_list.length; i++) {
	  if (phone_list[i].length == 8 || phone_list[i].length == 7 || phone_list[i].length == 11) {
		yse_phone.push(phone_list[i])
	  }
	}
	if (yse_phone.length == 1) {
	  wx.makePhoneCall({
		phoneNumber: yse_phone[0]
	  })
	} else {
	  if (yse_phone.length != 0) {
		this.setData({
		  phoneNumber: yse_phone,
		  block: true
		})
	 }
}
}
//返回10位时间戳
export function unitConversion(number) {
	if(number>9999){
	  number = parseInt(number/1000)
	  number = parseFloat(number/10)
	  number = number+'w'
	}
	return number;
}

//屏蔽手机号中间4位
export function shieldMobile(number) {
	if (Number(number) && String(number).length === 11) {
		var reg = /^(\d{3})\d{4}(\d{4})$/;
		number = number.replace(reg, "$1****$2");
	}
	return number;
}

/* 
floor 向下  
ceil 进一  
round 四舍五入
*/
export function calculateDiscount(original, discount, type = false, math_type = 'round'){
	// console.log(type);
	const math_func = Math[math_type];
	if(type){
		//   ((原价-优惠价)=现价)/原价＝折扣
		//折扣是% 所以要 *100
		const p = math_func(original * 100 + (-discount * 100))
		return calculate(p, '/', original, 2, math_type);
	}else{

		//折扣是% 所以需要/100
		//原价 -（原价x折扣＝现价） = 优惠金额
		const p  = (math_func(original * 100) * math_func(discount * 100)) / 1000000
		return calculate(original,'-', p, 2, math_type);

	}

}

//加减乘除
export function calculate(arg1, type, arg2, num = 2, math_type = 'round'){
	const math_func = Math[math_type];
	if(type == '+'){
		return ((math_func(arg1 * 100) + math_func(arg2 * 100)) / 100).toFixed(num);
	}else if(type == '-'){
		return ((math_func(arg1 * 100) + math_func(-arg2 * 100)) / 100).toFixed(num);
	}else if(type == '*'){
		 return ((math_func(arg1 * 100) * math_func(arg2 * 100)) / 10000).toFixed(num);
	}else{
		var d1, d2,
		   n1 = Number(arg1.toString().replace(".", "")),
		   n2 = Number(arg2.toString().replace(".", ""));
		 try {d1 = arg1.toString().split(".")[1].length;} catch (e) {d1 = 0;}
		 try {d2 = arg2.toString().split(".")[1].length;} catch (e) {d2 = 0;}
		return ((n1 / n2) * Math.pow(10, d2 - d1)).toFixed(num);
	}
}

export function calculateFormula(array = [], math_type = 'round'){
	let result = 0;	
	let type = '+'
	 
	array.forEach(item => {
		if (['+', '-', '*','/'].includes(item)) {
			type = item
		}else{
			result += Number(item);
		}
		
	});

	return result;
}



//小数点后两位
export function currencyFilters(value) {
	if (!value) return '0.00'
	var floatPart = ".00"; //预定义小数部分
	var value2Array = value.toString().split(".");
	var intPart = Number(value) - Number(value)%1;
	// var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
	//=2表示数据有小数位
	if(value2Array.length == 2) {
		floatPart = value2Array[1].toString(); //拿到小数部分

		if(floatPart.length == 1) { //补0,实际上用不着
			return intPart + "." + floatPart + '0';
		} else {
			return intPart + "." + floatPart;
		}

	} else {
		return intPart + floatPart;
	}
}

export function checkBarCode(str) {

	//判断是否为正整数
	　	if(!(/(^[1-9]\d*$)/.test(str))) {
	　　　　　	return false;
	　　　　}else {
				return true;
	　　　　　
	　　　　}
	//获取校验位
	   // let sum = 0;
	   // for(let i =1;i<12;i+=2){
		  //  sum+=(str.charAt(i)-'0');
	   // }
	   // let sum2 =0;
	   // for(let i = 0;i<12;i+=2){
		  //  sum2 += (str.charAt(i)-'0');
	   // }
	   // let count =sum*3+sum2;
	   // if(10-count%10==(str.charAt(12)-'0')){
		  //  return true;
	   // }else{
		  // return false;
	   // }
}

//制保留2位小数，如：2，会在2后面补上00.即2.00 
export function  toDecimal2(x) {
	var f = parseFloat(x);
	if (isNaN(f)) { 
		return false; 
	} 
	var f = Math.round(x*100)/100; 
	var s = f.toString(); 
	var rs = s.indexOf('.'); 
	if (rs < 0) { 
		rs = s.length; 
		s += '.'; 
	} 
	while (s.length <= rs + 2) { 
		s += '0'; 
	} 
	return s; 
}
export default {
	checkBarCode,
	encodeSearchParams,
	encodeSearchParams2,
	sortObj,
	signVerify,
	valueCheck,
	timest,
	objToArray,
	htmlReplaceImgUrl,
	clickPhone,
	unitConversion,
	formatTime,
	shieldMobile,
	trimArray,
	calculate,
	calculateDiscount,
	currencyFilters,
	toDecimal2
}



// WEBPACK FOOTER //
// ./src/api/common.js